import {useMutation, useQueryClient} from "@tanstack/react-query";
import api from "../../utils/api.ts";
import {useContext} from "react";
import MessageContext from "../../context/MessageContext.tsx";
import {useNavigate} from "react-router";
import {track} from "../../utils/analytics.ts";

export const useSaveFitout = (type: SaveItemType, id: string | undefined, itemPath: string = `/cargo/${type}`) => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const {success, error} = useContext(MessageContext);

    return useMutation({
        mutationFn: async (data: Partial<SavedState>) => {
            return await api.post(`/persistence/${type}/save`, data);
        },
        onSuccess: (response, data) => {
            track(`${type}:save`, {isNew: !data.id, isPublic: data.isPublic});
            success('Data saved');
             if (!id || id !== response.data.id) {
                navigate(`${itemPath}/${response.data.id}`)
            } else {
                queryClient.invalidateQueries({
                    queryKey: ['persistence', type, id]
                })
            }
            queryClient.invalidateQueries({
                queryKey: ['persistence', type]
            })
            queryClient.invalidateQueries({
                queryKey: ['persistence', type, 'count']
            })
        },
        onError: (err: any) => {
             error('Error saving data', err.message);
        }
    });
}
